import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import useWindowDimensions from "../../useWindowDimensions";

import "./style.less";

import moment from "moment/moment";
import { useEffect } from "react";

import axios from "axios";

function formatText(text = "") {
  // Split the text by underscores
  const words = text.split("_");

  // Capitalize the first letter of each word and join them with a space
  const formattedText = words
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

  return formattedText;
}

const TrackingDetails = (props) => {
  const { height, width } = useWindowDimensions();
  const [trackerOrderNo, settrackerOrder] = useState("");
  const [trackerOrderData, setTrackerOrderData] = useState("");
  const [orderData, setOrderData] = useState();
  const [loading, setloading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const { t } = useTranslation();
  const [stepCount, setStepCount] = useState(1);

  useEffect(() => {
    if (props?.location?.state) {
      settrackerOrder(props?.location?.state);
      trackOrderBtnClick(props?.location?.state);
    }
  }, []);

  const trackOrderBtnClick = async (num) => {
    setTrackerOrderData();
    setErrorMsg("");
    const number = trackerOrderNo?.trim() || num?.trim();
    if (number?.length < 5) {
      alert("Please enter track order number");
    } else {
      setloading(true);

      try {
        // const data = await axios.post(
        // 	'https://wyngs.speedboxapp.com/speedbox/api/v1/trackShipment',
        // 	{ orderNumber: [number] },
        // 	{
        // 		headers: {
        // 			Authorization:
        // 				'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI2NGVlZjRlNzU4MWJmMzAwMDhhYTVhYmYiLCJfc2lkIjoiZGU5YzAxYTAtNTBiNi0xMWVlLThlZDAtYTFkOTgxMzRhM2I4IiwibG9nZ2VkSW5UaW1lIjoiMjAyMy0wOS0xMVQxNToyMToyNS4xMjFaIiwiaWF0IjoxNjk0NDQ1Njg1fQ.J98OX8rADdUA_yDhq-F-op4zFgNJE8lOnyYzeK0jVi8',
        // 		},
        // 	}
        // )
        const data = await axios.get(
          "https://wyngs-my.speedboxapp.com/prod/api/v2/tracking/track/single",

          {
            params: {
              shipmentNumber: [number],
            },
          }
        );
        setTrackerOrderData(data.data.data[0]);
        setloading(false);

        switch (data?.data?.data[0]?.status) {
          case "in_transit":
            setStepCount(3);
            break;

          case "delivered":
            setStepCount(4);
            break;

          case "placed":
            setStepCount(1);
            break;

          default:
            setStepCount(2);
            break;
        }
      } catch (error) {
        setErrorMsg(error?.response?.data?.msg || "Something went wrong");
        setloading(false);
      }
    }
  };
  return (
    <>
      <section className="trackingDetailsSec1 wow fadeIn">
        <div className="d-f trackInputBoxContainer">
          <div className="cont1 d-f j-c a-c">
            <div className="icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M8.63633 2.5C7.42268 2.5 6.23628 2.85989 5.22717 3.53416C4.21806 4.20843 3.43155 5.16679 2.9671 6.28806C2.50266 7.40932 2.38114 8.64314 2.61791 9.83347C2.85468 11.0238 3.43911 12.1172 4.29729 12.9754C5.15547 13.8335 6.24886 14.418 7.43919 14.6547C8.62952 14.8915 9.86334 14.77 10.9846 14.3056C12.1059 13.8411 13.0642 13.0546 13.7385 12.0455C14.4128 11.0364 14.7727 9.84998 14.7727 8.63633C14.7726 7.0089 14.126 5.44817 12.9753 4.2974C11.8245 3.14664 10.2638 2.5001 8.63633 2.5Z"
                  stroke="#AEA9B4"
                  stroke-width="1.5"
                  stroke-miterlimit="10"
                />
                <path
                  d="M13.2148 13.2145L17.5004 17.5"
                  stroke="#AEA9B4"
                  stroke-width="1.5"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                />
              </svg>
            </div>
            <input
              type="number"
              placeholder={t("homepage.trackorderPlaceHolder")}
              className="trackOrder"
              value={trackerOrderNo}
              onChange={(e) => settrackerOrder(e.target.value)}
            />
          </div>

          <div onClick={trackOrderBtnClick} className="viewMoreBtnClick">
            <div className="txt">Track</div>

            <svg
              width="17"
              height="18"
              viewBox="0 0 17 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g id="vuesax/outline/location">
                <g id="location">
                  <path
                    id="Vector"
                    d="M8.49906 10.0371C7.26561 10.0371 6.25781 9.03466 6.25781 7.79581C6.25781 6.55865 7.26392 5.56165 8.49906 5.56165C9.73251 5.56165 10.7403 6.56405 10.7403 7.8029C10.7403 9.04006 9.7342 10.0371 8.49906 10.0371ZM8.49906 5.62415C7.30346 5.62415 6.32031 6.59747 6.32031 7.8029C6.32031 9.00695 7.295 9.98165 8.49906 9.98165C9.70312 9.98165 10.6778 9.00695 10.6778 7.8029C10.6778 6.59747 9.69467 5.62415 8.49906 5.62415Z"
                    fill="#101828"
                    stroke="white"
                  />
                  <path
                    id="Vector_2"
                    d="M2.53376 6.51162L2.53389 6.51106C3.25618 3.32906 6.03028 1.88538 8.49921 1.88538H8.49921H8.49922H8.49922H8.49923H8.49923H8.49923H8.49924H8.49924H8.49925H8.49925H8.49925H8.49926H8.49926H8.49927H8.49927H8.49928H8.49928H8.49929H8.49929H8.49929H8.4993H8.4993H8.49931H8.49931H8.49932H8.49932H8.49933H8.49933H8.49934H8.49935H8.49935H8.49936H8.49936H8.49937H8.49938H8.49938H8.49939H8.4994H8.4994H8.49941H8.49941H8.49941H8.49942H8.49942H8.49943H8.49943H8.49943H8.49944H8.49944H8.49945H8.49945H8.49946H8.49946H8.49946H8.49947H8.49947H8.49948H8.49948H8.49949H8.49949H8.4995H8.4995H8.49951H8.49951H8.49952H8.49952H8.49953H8.49953H8.49954H8.49954H8.49955H8.49956H8.49956H8.49957H8.49957H8.49958H8.49958H8.49959H8.4996H8.4996H8.49961H8.49961H8.49962H8.49963H8.49963H8.49964H8.49964H8.49965H8.49966H8.49966H8.49967H8.49968H8.49968H8.49969H8.4997H8.49971H8.49971H8.49972H8.49973H8.49973H8.49974H8.49975H8.49976H8.49976H8.49977H8.49978H8.49979H8.49979H8.4998H8.49981H8.49982H8.49983H8.49984H8.49984H8.49985H8.49986H8.49987H8.49988H8.49989H8.49989H8.4999H8.49991H8.49992H8.49993H8.49994H8.49995H8.49996H8.49997H8.49998H8.49999H8.5H8.50001H8.50001H8.50002H8.50003H8.50004H8.50005H8.50006H8.50007H8.50008H8.5001H8.50011H8.50012H8.50013H8.50014H8.50015H8.50016H8.50017H8.50018H8.50019H8.5002H8.50021H8.50023H8.50024H8.50025H8.50026H8.50027H8.50028H8.5003H8.50031H8.50032H8.50033H8.50034H8.50036H8.50037H8.50038H8.50039H8.50041H8.50042H8.50043H8.50044H8.50046H8.50047H8.50048H8.5005H8.50051H8.50052H8.50054H8.50055H8.50056H8.50058H8.50059H8.50061H8.50062H8.50063H8.50065H8.50066H8.50068H8.50069H8.50071H8.50072H8.50074H8.50075H8.50077H8.50078H8.5008H8.50081H8.50083H8.50084H8.50086H8.50087H8.50089H8.50091H8.50092H8.50094H8.50096H8.50097H8.50099H8.501H8.50102H8.50104H8.50106H8.50107H8.50109H8.50111H8.50112H8.50114H8.50116H8.50118H8.50119H8.50121H8.50123H8.50125H8.50127H8.50128H8.5013H8.50132H8.50134H8.50136H8.50138H8.5014H8.50141H8.50143H8.50145H8.50147H8.50149H8.50151H8.50153H8.50155H8.50157H8.50159H8.50161H8.50163H8.50165H8.50167H8.50169H8.50171H8.50173H8.50176H8.50178H8.5018H8.50182H8.50184H8.50186H8.50188H8.5019H8.50193H8.50195H8.50197H8.50199H8.50202H8.50204H8.50206H8.50208H8.50211H8.50213H8.50215H8.50217H8.5022H8.50222H8.50224H8.50227H8.50229H8.50232H8.50234H8.50236H8.50239H8.50241H8.50244H8.50246H8.50249H8.50251H8.50254H8.50256H8.50259H8.50261H8.50264H8.50266H8.50269H8.50272H8.50274H8.50277H8.50279H8.50282H8.50285H8.50287H8.5029H8.50293H8.50295H8.50298H8.50301H8.50304H8.50306H8.50309H8.50312H8.50315H8.50318H8.5032H8.50323H8.50326H8.50329H8.50332H8.50335H8.50338H8.50341H8.50344H8.50346H8.50349H8.50352H8.50355H8.50358H8.50361H8.50364H8.50367H8.50371H8.50374H8.50377H8.5038H8.50383H8.50386H8.50389H8.50392H8.50396H8.50399H8.50402H8.50405H8.50408H8.50412H8.50415H8.50418H8.50421H8.50425H8.50428H8.50431H8.50435H8.50438H8.50441H8.50445H8.50448H8.50452H8.50455H8.50458H8.50462H8.50465H8.50469H8.50472H8.50476H8.50479H8.50483H8.50487H8.5049H8.50494H8.50497H8.50501H8.50505H8.50508H8.50512H8.50516H8.50519H8.50523H8.50527H8.50531H8.50534H8.50538H8.50542H8.50546H8.5055H8.50553H8.50557H8.50561H8.50565H8.50569H8.50573H8.50577H8.50581H8.50585H8.50589H8.50593H8.50597H8.50601H8.50605H8.50609H8.50613H8.50617H8.50621H8.50625H8.50629C10.9749 1.88538 13.7491 3.32872 14.4715 6.51784C15.2745 10.0655 13.1384 13.0946 11.0784 15.078C10.3519 15.7729 9.42137 16.1216 8.49921 16.1216C7.57708 16.1216 6.64656 15.7729 5.92008 15.078C3.86029 13.0949 1.72424 10.059 2.53376 6.51162ZM14.4128 6.52434L14.4124 6.52235C13.6352 3.13374 10.7092 1.94788 8.49921 1.94788C6.2889 1.94788 3.3698 3.13415 2.60007 6.5229C1.77229 10.1342 4.04911 13.1839 5.97094 15.027C7.38995 16.3961 9.61574 16.3961 11.0347 15.0269C12.9493 13.1839 15.2254 10.1348 14.4128 6.52434Z"
                    fill="#101828"
                    stroke="white"
                  />
                </g>
              </g>
            </svg>
          </div>
        </div>
        {loading && <div className="loadingTxt">Loading...</div>}
        {errorMsg && <div className="loadingTxt">{errorMsg}</div>}
        {trackerOrderData && (
          <div className="trackOrderList">
            <div className="orderStatusText">
              Order Id: {trackerOrderData?.orderNumber}
            </div>

            <div className="d-f jc-sb ">
              <div className="d-f f-c">
                <div className="orderStatus">
                  {formatText(trackerOrderData?.status)}
                </div>
                <div className="OrderDateTxt">
                  Order date:
                  {moment(trackerOrderData?.createdAt).format("MMMM Do YYYY")}
                </div>
                <div className="OrderDateTxt">
                  Location:
                  {trackerOrderData?.destination}
                </div>
              </div>
            </div>

            <div className="trackingDataContainerLine"></div>
            <div className="orderStatusText">Tracking Summary</div>
            <div className="track">
              <div className="step first active">
                <div className="icon">
                  <svg
                    width="60"
                    height="60"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="30" cy="30" r="28" fill="#12B76A" />
                    <svg
                      x="10"
                      y="10"
                      width="41"
                      height="40"
                      viewBox="0 0 41 40"
                      fill="#12B76A"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g id="task_alt_FILL0_wght400_GRAD0_opsz24 1">
                        <path
                          id="Vector"
                          d="M20.3756 36.358C18.1127 36.358 15.9862 35.9286 13.996 35.0698C12.0057 34.211 10.2745 33.0455 8.8023 31.5733C7.33008 30.1011 6.16457 28.3698 5.30577 26.3796C4.44698 24.3894 4.01758 22.2629 4.01758 20C4.01758 17.7371 4.44698 15.6106 5.30577 13.6204C6.16457 11.6301 7.33008 9.89891 8.8023 8.42669C10.2745 6.95447 12.0057 5.78896 13.996 4.93016C15.9862 4.07137 18.1127 3.64197 20.3756 3.64197C22.1477 3.64197 23.8244 3.90097 25.4057 4.41897C26.987 4.93698 28.4456 5.65946 29.7815 6.58641L27.4096 8.99922C26.3735 8.3449 25.2694 7.83371 24.0971 7.46566C22.9247 7.0976 21.6842 6.91357 20.3756 6.91357C16.7496 6.91357 13.662 8.18814 11.1129 10.7373C8.56375 13.2864 7.28918 16.374 7.28918 20C7.28918 23.626 8.56375 26.7136 11.1129 29.2627C13.662 31.8118 16.7496 33.0864 20.3756 33.0864C24.0016 33.0864 27.0892 31.8118 29.6383 29.2627C32.1875 26.7136 33.462 23.626 33.462 20C33.462 19.5093 33.4348 19.0185 33.3802 18.5278C33.3257 18.037 33.2439 17.5599 33.1349 17.0964L35.793 14.4383C36.0929 15.3107 36.3247 16.2104 36.4883 17.1373C36.6518 18.0643 36.7336 19.0185 36.7336 20C36.7336 22.2629 36.3042 24.3894 35.4454 26.3796C34.5866 28.3698 33.4211 30.1011 31.9489 31.5733C30.4767 33.0455 28.7455 34.211 26.7552 35.0698C24.765 35.9286 22.6385 36.358 20.3756 36.358ZM18.0855 27.5247L11.1333 20.5725L13.4234 18.2824L18.0855 22.9444L34.4435 6.54552L36.7336 8.83564L18.0855 27.5247Z"
                          fill="white"
                        />
                      </g>
                    </svg>
                  </svg>
                </div>
                <span style={{ color: "#1DBF73" }} className="text">
                  Order confirmed
                </span>
              </div>
              <div className={stepCount >= 2 ? "step active" : "step"}>
                <div className="icon">
                  <svg
                    width="60"
                    height="60"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="30" cy="30" r="28" fill="#12B76A" />
                    <svg
                      x="10"
                      y="10"
                      width="41"
                      height="40"
                      viewBox="0 0 41 40"
                      fill="#12B76A"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g id="local_shipping_FILL0_wght400_GRAD0_opsz24 1">
                        <g id="Layer 31">
                          <path
                            id="Vector"
                            d="M5.20166 11.1346H5.22751L5.09145 11.2788L5.09145 11.2788L5.09088 11.2794C4.9537 11.4258 4.875 11.6173 4.875 11.8202V33.3937C4.875 33.8259 5.22614 34.1766 5.65873 34.1766H34.5912C35.0238 34.1766 35.3749 33.8259 35.3749 33.3937V11.8202C35.3749 11.6172 35.2962 11.4258 35.1591 11.2794L35.1575 11.2777L35.0208 11.1346H35.0484L34.7255 10.7289L31.0469 6.10729L31.047 6.10727L31.0444 6.10408C30.8975 5.92571 30.6748 5.82349 30.443 5.82349H9.80611C9.57081 5.82349 9.34926 5.92702 9.19955 6.11038L9.19954 6.11036L9.19758 6.11282L5.52445 10.7289L5.20166 11.1346ZM24.5064 7.39001H30.0661L32.9678 11.0373H26.3286L26.3042 10.9898L26.303 10.9875L24.5064 7.39001ZM17.8461 7.39001H22.7536L24.5749 11.0373H16.0249L17.8461 7.39001ZM24.731 12.6141V19.7276H15.8697V12.6141H24.731ZM7.28217 11.0373L10.1839 7.39001H16.0943L14.273 11.0373H7.28217ZM33.8076 32.6081H6.44252V12.6034L14.3031 12.6137V20.5104C14.3031 20.9416 14.6514 21.296 15.086 21.296C15.4323 21.296 15.7249 21.0708 15.8291 20.7604H16.0815C16.1856 21.0706 16.4779 21.296 16.8237 21.296C17.1695 21.296 17.4631 21.071 17.5676 20.7604H17.8193C17.9236 21.0707 18.2166 21.296 18.5614 21.296C18.9073 21.296 19.2008 21.071 19.3053 20.7604H19.557C19.6614 21.0709 19.9546 21.296 20.3 21.296C20.6453 21.296 20.9385 21.0709 21.0429 20.7604H21.2955C21.3996 21.0707 21.6922 21.296 22.0385 21.296C22.3851 21.296 22.6769 21.0705 22.7807 20.7604H23.034C23.1378 21.0705 23.4295 21.296 23.7762 21.296C24.1229 21.296 24.4146 21.0705 24.5185 20.7604H24.7718C24.8759 21.0706 25.1682 21.296 25.5139 21.296C25.9479 21.296 26.2977 20.9422 26.2977 20.5104V12.6137L33.8076 12.6034V32.6081Z"
                            fill="white"
                            stroke="white"
                            stroke-width="0.5"
                          />
                        </g>
                      </g>
                    </svg>
                  </svg>
                </div>
                <span className="text">Picked up</span>
              </div>
              <div className={stepCount >= 3 ? "step active" : "step"}>
                <div className="icon ">
                  <svg
                    width="60"
                    height="60"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="30" cy="30" r="28" fill="#12B76A" />
                    <svg
                      x="10"
                      y="10"
                      width="41"
                      height="40"
                      viewBox="0 0 41 40"
                      fill="#12B76A"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g id="local_shipping_FILL0_wght400_GRAD0_opsz24 1">
                        <g id="Layer 31">
                          <path
                            id="Vector"
                            d="M35.585 17.32L31.585 13.32C31.4941 13.2219 31.3844 13.143 31.2624 13.088C31.1405 13.0331 31.0087 13.0031 30.875 13H23.875V10C23.875 9.73478 23.7696 9.48043 23.5821 9.29289C23.3946 9.10536 23.1402 9 22.875 9H6.875C6.60978 9 6.35543 9.10536 6.16789 9.29289C5.98036 9.48043 5.875 9.73478 5.875 10C5.875 10.2652 5.98036 10.5196 6.16789 10.7071C6.35543 10.8946 6.60978 11 6.875 11H21.875V25H15.335C15.265 24.88 15.185 24.77 15.105 24.65L15.055 24.58C14.9416 24.4254 14.8144 24.2815 14.675 24.15L14.555 24.04C14.4563 23.948 14.3528 23.8612 14.245 23.78L14.075 23.7L13.765 23.51L13.565 23.41L13.235 23.28L13.025 23.21L12.645 23.11H12.465C12.0745 23.0434 11.6755 23.0434 11.285 23.11H11.095L10.725 23.19L10.505 23.27L10.205 23.39L9.965 23.51L9.715 23.66C9.63446 23.7075 9.55758 23.761 9.485 23.82L9.295 24L9.045 24.22V24.27C8.84924 24.475 8.675 24.6995 8.525 24.94L8.415 25H6.875C6.60978 25 6.35543 25.1054 6.16789 25.2929C5.98036 25.4804 5.875 25.7348 5.875 26C5.875 26.2652 5.98036 26.5196 6.16789 26.7071C6.35543 26.8946 6.60978 27 6.875 27H7.875C7.875 28.0609 8.29643 29.0783 9.04657 29.8284C9.79672 30.5786 10.8141 31 11.875 31C12.9359 31 13.9533 30.5786 14.7034 29.8284C15.4536 29.0783 15.875 28.0609 15.875 27H24.875C24.875 28.0609 25.2964 29.0783 26.0466 29.8284C26.7967 30.5786 27.8141 31 28.875 31C29.9359 31 30.9533 30.5786 31.7034 29.8284C32.4536 29.0783 32.875 28.0609 32.875 27H34.875C35.1402 27 35.3946 26.8946 35.5821 26.7071C35.7696 26.5196 35.875 26.2652 35.875 26V18C35.864 17.7457 35.7609 17.504 35.585 17.32ZM11.875 29C11.3446 29 10.8359 28.7893 10.4608 28.4142C10.0857 28.0391 9.875 27.5304 9.875 27C9.87443 26.7671 9.91856 26.5363 10.005 26.32C10.1442 25.9351 10.3981 25.6021 10.7325 25.366C11.0669 25.13 11.4657 25.0022 11.875 25C12.2926 25.001 12.6994 25.1327 13.0383 25.3766C13.3773 25.6205 13.6314 25.9644 13.765 26.36C13.8387 26.5653 13.8759 26.7819 13.875 27C13.875 27.5304 13.6643 28.0391 13.2892 28.4142C12.9141 28.7893 12.4054 29 11.875 29ZM28.875 29C28.3446 29 27.8359 28.7893 27.4608 28.4142C27.0857 28.0391 26.875 27.5304 26.875 27C26.8744 26.7671 26.9186 26.5363 27.005 26.32C27.1442 25.9351 27.3981 25.6021 27.7325 25.366C28.0669 25.13 28.4657 25.0022 28.875 25C29.2926 25.001 29.6994 25.1327 30.0383 25.3766C30.3773 25.6205 30.6314 25.9644 30.765 26.36C30.8387 26.5653 30.8759 26.7819 30.875 27C30.875 27.5304 30.6643 28.0391 30.2892 28.4142C29.9141 28.7893 29.4054 29 28.875 29ZM33.875 25H32.335C32.265 24.88 32.185 24.77 32.105 24.65L32.055 24.58C31.9416 24.4254 31.8144 24.2815 31.675 24.15L31.555 24.04C31.4563 23.948 31.3528 23.8612 31.245 23.78L31.075 23.67L30.765 23.48L30.565 23.38L30.235 23.25L30.025 23.18L29.645 23.08H29.465C29.0745 23.0134 28.6755 23.0134 28.285 23.08H28.095L27.725 23.16L27.505 23.24L27.205 23.36L26.965 23.48L26.715 23.63C26.6345 23.6775 26.5576 23.731 26.485 23.79L26.295 23.94L26.045 24.16V24.21C25.8492 24.415 25.675 24.6395 25.525 24.88L25.455 24.99H23.875V15H30.465L33.875 18.44V25ZM5.875 14C5.875 13.7348 5.98036 13.4804 6.16789 13.2929C6.35543 13.1054 6.60978 13 6.875 13H16.875C17.1402 13 17.3946 13.1054 17.5821 13.2929C17.7696 13.4804 17.875 13.7348 17.875 14C17.875 14.2652 17.7696 14.5196 17.5821 14.7071C17.3946 14.8946 17.1402 15 16.875 15H6.875C6.60978 15 6.35543 14.8946 6.16789 14.7071C5.98036 14.5196 5.875 14.2652 5.875 14ZM5.875 18C5.875 17.7348 5.98036 17.4804 6.16789 17.2929C6.35543 17.1054 6.60978 17 6.875 17H13.875C14.1402 17 14.3946 17.1054 14.5821 17.2929C14.7696 17.4804 14.875 17.7348 14.875 18C14.875 18.2652 14.7696 18.5196 14.5821 18.7071C14.3946 18.8946 14.1402 19 13.875 19H6.875C6.60978 19 6.35543 18.8946 6.16789 18.7071C5.98036 18.5196 5.875 18.2652 5.875 18ZM5.875 22C5.875 21.7348 5.98036 21.4804 6.16789 21.2929C6.35543 21.1054 6.60978 21 6.875 21H8.875C9.14022 21 9.39457 21.1054 9.58211 21.2929C9.76964 21.4804 9.875 21.7348 9.875 22C9.875 22.2652 9.76964 22.5196 9.58211 22.7071C9.39457 22.8946 9.14022 23 8.875 23H6.875C6.60978 23 6.35543 22.8946 6.16789 22.7071C5.98036 22.5196 5.875 22.2652 5.875 22Z"
                            fill="#7A7A7A"
                          />
                        </g>
                      </g>
                    </svg>
                  </svg>
                </div>
                <span className="text">In Transit</span>
              </div>
              <div
                style={{ width: "auto" }}
                className={
                  stepCount === 4 ? "step last active p-r" : "step last p-r"
                }
              >
                <div className="icon">
                  <svg
                    width="60"
                    height="60"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="30" cy="30" r="28" fill="#12B76A" />
                    <svg
                      x="10"
                      y="10"
                      width="41"
                      height="40"
                      viewBox="0 0 41 40"
                      fill="#12B76A"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g id="local_shipping_FILL0_wght400_GRAD0_opsz24 1">
                        <g id="Layer 31">
                          <g id="Group 9">
                            <path
                              id="Vector"
                              d="M13.4292 20.6614C13.3805 20.5751 13.238 20.5751 13.1855 20.6614L12.1017 22.5401C12.0755 22.5851 12.0755 22.6376 12.1017 22.6826C12.128 22.7239 12.173 22.7501 12.2217 22.7501H12.6342V24.8689C12.6342 24.9476 12.698 25.0114 12.7767 25.0114H13.8417C13.9167 25.0114 13.9805 24.9476 13.9805 24.8689V22.7501H14.393C14.4417 22.7501 14.4905 22.7239 14.513 22.6826C14.5392 22.6376 14.5392 22.5851 14.513 22.5401L13.4292 20.6614Z"
                              fill="black"
                            />
                            <path
                              id="Vector_2"
                              d="M9.76508 22.7501V24.8689C9.76508 24.9476 9.82883 25.0114 9.90758 25.0114H10.9726C11.0513 25.0114 11.1113 24.9476 11.1113 24.8689V22.7501H11.5238C11.5726 22.7501 11.6213 22.7239 11.6438 22.6826C11.6701 22.6376 11.6701 22.5851 11.6438 22.5401L10.5601 20.6614C10.5113 20.5751 10.3688 20.5751 10.3163 20.6614L9.23258 22.5401C9.20633 22.5851 9.20633 22.6376 9.23258 22.6826C9.25883 22.7239 9.30383 22.7501 9.35633 22.7501H9.76508Z"
                              fill="black"
                            />
                            <path
                              id="Vector_3"
                              d="M14.2943 25.5138H9.45305C9.3743 25.5138 9.31055 25.5775 9.31055 25.6525V26.755C9.31055 26.83 9.3743 26.8938 9.45305 26.8938H14.2943C14.3693 26.8938 14.433 26.83 14.433 26.755V25.6525C14.433 25.5775 14.3693 25.5138 14.2943 25.5138Z"
                              fill="black"
                            />
                            <path
                              id="Vector_4"
                              d="M31.0687 20.515V7.11255C31.0687 5.97255 30.1425 5.05005 29.0062 5.05005H7.6875C6.55125 5.05005 5.625 5.97255 5.625 7.11255V28.4313C5.625 29.5675 6.55125 30.4938 7.6875 30.4938H22.2337C23.4338 32.7325 25.7962 34.2625 28.5112 34.2625C32.4338 34.2625 35.625 31.0713 35.625 27.1488C35.625 24.1263 33.7312 21.5463 31.0687 20.515ZM15.5588 6.17505H21.135V15.325L18.8888 14.0275C18.555 13.8363 18.1388 13.8363 17.805 14.0275L15.5588 15.325V6.17505ZM21.7537 29.3688H7.6875C7.17 29.3688 6.75 28.9488 6.75 28.4313V7.11255C6.75 6.59505 7.17 6.17505 7.6875 6.17505H14.4338V15.4C14.4338 15.79 14.6363 16.1388 14.9738 16.3375C15.1425 16.4351 15.33 16.4838 15.5175 16.4838C15.705 16.4838 15.8888 16.4351 16.0575 16.3375L18.3488 15.0138L20.6362 16.3375C20.9775 16.5325 21.3825 16.5325 21.72 16.3375C22.0575 16.1388 22.26 15.79 22.26 15.4V6.17505H29.0062C29.5238 6.17505 29.9437 6.59505 29.9437 7.11255V20.1775C29.4788 20.0838 29.0025 20.0313 28.5112 20.0313C24.585 20.0313 21.3937 23.2263 21.3937 27.1488C21.3937 27.9251 21.5212 28.6675 21.7537 29.3688ZM28.5112 33.1375C25.2075 33.1375 22.5187 30.4526 22.5187 27.1488C22.5187 23.8451 25.2075 21.1563 28.5112 21.1563C31.815 21.1563 34.5 23.8451 34.5 27.1488C34.5 30.4526 31.8112 33.1375 28.5112 33.1375Z"
                              fill="black"
                            />
                            <path
                              id="Vector_5"
                              d="M30.2668 25.3564L27.8743 27.7489L26.753 26.6276C26.5355 26.4101 26.1793 26.4101 25.958 26.6276C25.7405 26.8489 25.7405 27.2051 25.958 27.4226L27.4768 28.9414C27.5855 29.0501 27.728 29.1064 27.8743 29.1064C28.0205 29.1064 28.1593 29.0501 28.2718 28.9414L31.0618 26.1514C31.283 25.9301 31.283 25.5739 31.0618 25.3564C30.8405 25.1351 30.4843 25.1351 30.2668 25.3564Z"
                              fill="black"
                            />
                          </g>
                        </g>
                      </g>
                    </svg>
                  </svg>
                </div>
                <span className="text">Delivered </span>
              </div>
            </div>
            <div className="trackingDataContainerLine"></div>

            <div className="d-f">
              <div className="orderStatusText">Shipment Summary</div>
              <div className="shipmentList d-f">
                <div className="c1">
                  <div className="headingTxt">Order no.</div>
                  <div className="headingTxt">Airway bill no.</div>
                  <div className="headingTxt">HUB</div>
                  <div className="headingTxt">Order placed date</div>
                  <div className="headingTxt">Origin city</div>
                  <div className="headingTxt">Destination</div>
                  <div className="headingTxt">Weight</div>
                </div>

                <div className="c2">
                  <div className="valueTxt">
                    {trackerOrderData?.orderNumber}
                  </div>
                  <div className="valueTxt">
                    {trackerOrderData?.carrierAirWayBillNumber ?? "-"}
                  </div>
                  <div className="valueTxt">{trackerOrderData?.systemName}</div>
                  <div className="valueTxt">
                    {moment(trackerOrderData?.createdAt).format("MMMM Do YYYY")}
                  </div>
                  <div className="valueTxt">{trackerOrderData?.origin}</div>
                  <div className="valueTxt">
                    {trackerOrderData?.destination}
                  </div>

                  <div className="valueTxt">{trackerOrderData?.weight} kg</div>
                </div>
              </div>
            </div>

            <div className="trackingDataContainerLine"></div>
            <div className="orderStatusText">Tracking History</div>
            <table className="orderList">
              <tr>
                <th>Date</th>
                <th>Location</th>
                <th>Activity</th>
                <th>Status</th>
              </tr>
              {trackerOrderData?.statusDetails?.map((item, i) => {
                return (
                  <tr key={i}>
                    <td>
                      <div>{moment(item?.timeStamp).format("DD MM YYYY")}</div>
                      <div>{moment(item?.timeStamp).format("hh:MM A")}</div>
                    </td>
                    <td>{item?.location}</td>
                    <td>{item?.msg}</td>
                    <td>{formatText(item?.status)}</td>
                  </tr>
                );
              })}
            </table>
          </div>
        )}
      </section>
    </>
  );
};

export default TrackingDetails;
